import { createTheme } from "@mui/material/styles";
import { DELTA_PRIMARY, DELTA_ACCENT, PAPER_GREY, BORDER_GREY } from "./colors";

export const theme = createTheme({
  palette: {
    primary: {
      main: DELTA_PRIMARY,
    },
    secondary: {
      main: DELTA_ACCENT,
    },
    background: {
      default: PAPER_GREY,
    },
  },
  typography: {
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    h1: { fontFamily: "'Poppins', sans-serif", fontWeight: 700 },
    h2: { fontFamily: "'Poppins', sans-serif", fontWeight: 700 },
    h3: { fontFamily: "'Poppins', sans-serif", fontWeight: 600, color: DELTA_ACCENT },
    h4: { fontFamily: "'Poppins', sans-serif", fontWeight: 600, color: DELTA_ACCENT },
    h5: { fontFamily: "'Poppins', sans-serif", fontWeight: 600 },
    h6: { fontFamily: "'Poppins', sans-serif", fontWeight: 600 },
    button: { textTransform: "none", fontWeight: 600 },
  },
  shape: {
    borderRadius: 10,
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          border: `1px solid ${BORDER_GREY}`,
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          fontWeight: 700,
          color: DELTA_PRIMARY,
          backgroundColor: PAPER_GREY,
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          fontWeight: 600,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
      },
    },
  },
});
